import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Loader, Icon, Select } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import { connect, actions } from '../../../../Store';
import {
  ResponsiveFlexWrapper,
  PartWrapper,
  SliderWrapper,
  AnimatedFormMessageWrapper,
  InfoBox,
  SpaceWrapper,
  FlexBox,
} from '../../../../Components/ReusableComponents';
import {
  formatPrice,
  __,
  orderStateTrans,
  formatDate,
} from '../../../../Utils';
import YearsSlider from '../../../../Components/YearsSlider';
import OrdersGraph from '../../../../Components/OrdersGraph';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import BaseList from '../../BaseList';
import months from '../../../../ContentConfig/mounths';
import FileViewDownload from '../../../../Components/FileViewDownload';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
`;

const AddToCartWrapperDesktop = styled.div`
  cursor: pointer;
  width: ${rem(30)};
  height: ${rem(30)};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${rem(2)};
  &:hover {
    background: #70af004d;
  }
`;

const StyledPartWrapper = styled(PartWrapper)`
  overflow-y: scroll;
  order: 2;
  padding-top: ${rem(20)};
  ${({ theme }) => theme.media.m`
  width: 65%;
  order: unset;
  padding-top: 0;
  overflow: unset;
`};
`;

const MonthsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Label = styled.div`
  font-weight: 700;
`;

const DownloadWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  padding: 0 ${rem(10)};
`;

class Orders extends BaseList {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: __('Objednávky'),
      notFoundMessage: __('Ľutujeme objednávky sa nenašli'),
      isProduct: true,
      displayedColumns: {},
      defaultFilter: [
        {
          id: 'type',
          values: ['orders'],
        },
      ],
      showPager: false,
      actualYear: new Date().getFullYear(),
      yearReloadLoading: false,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      orders: [],
      summary: [],
      limit: 1000,
      offset: 0,
      total: 0,
      month: null,
      q: '',
      sorter: 'Document_Date',
      showOrderCopieddPopup: false,
    };

    actions.setActiveMenuItem('49');
  }

  async componentDidMount() {
    await this.fetchData();
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;

    switch (s) {
      case __('ČÍSLO'):
        if (sorter === 'No') {
          newSorter = '-No';
        } else {
          newSorter = 'No';
        }
        break;
      case __('DÁTUM'):
        if (sorter === 'Document_Date') {
          newSorter = '-Document_Date';
        } else {
          newSorter = 'Document_Date';
        }
        break;
      case __('SUMA S DPH'):
        if (sorter === 'Price') {
          newSorter = '-Price';
        } else {
          newSorter = 'Price';
        }
        break;
      case __('STAV'):
        if (sorter === 'Status') {
          newSorter = '-Status';
        } else {
          newSorter = 'Status';
        }
        break;
      default:
        newSorter = '';
        break;
    }

    this.fetchData({ sorter: newSorter });
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText, actualYear, month } = this.state;

      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (actualYear) {
        params.year = actualYear;
      }

      if (month && month >= 0) {
        params.month = month;
      }

      const newData = await API2.getB2bOrdersAction(params);
      this.setState({
        tableItems: newData.items || [],
        summary: newData.summary || [],
        loading: false,
        filtersDisabled: false,
        yearLoading: false,
        tableLoading: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.log(e);
      this.setState({ error: __('Nepodarilo sa načitať objednávky') });
    }
  }

  handleYearChange(side) {
    let { actualYear } = this.state;
    if (side === 'right') {
      if (actualYear + 1 > new Date().getFullYear()) {
        return;
      }
      actualYear += 1;
    } else {
      actualYear -= 1;
    }

    this.setState(
      {
        yearLoading: true,
        actualYear,
      },
      () => this.fetchData(),
    );
  }

  async createCartFromOrder(orderId) {
    this.setState({
      loading: false,
      copyOrderLoading: orderId,
    });

    try {
      // Move to APIv2
      // await API2.postB2BOrderDuplicateAction(orderId);

      this.setState({
        loading: false,
        copyOrderLoading: '',
        showOrderCopieddPopup: true,
      });
    } catch (e) {
      this.setState({
        loading: false,
        copyOrderLoading: '',
        error: __('Nepodarilo sa načítať objednávky'),
      });
    }
  }

  openOrderDetail(id) {
    this.props.history.push(`../shop/orders/${id}`);
  }

  createColumns(sorter) {
    return [
      {
        accessor: 'No',
        Header: () => (
          <IconTd sorter={sorter === 'No' || sorter === '-No' ? sorter : null}>
            {__('ČÍSLO')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P onClick={() => this.openOrderDetail(props.original.No)}>
              {props.value}
            </P>
          );
        },
      },
      {
        accessor: 'Order_Date',
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('DÁTUM')}
            sorter={sorter === 'Date' || sorter === '-Date' ? sorter : null}
          >
            {__('DÁTUM')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P
              onClick={() => this.openOrderDetail(props.original.No)}
              style={{ textAlign: 'end' }}
            >
              {formatDate(moment(props.value))}
            </P>
          );
        },
        maxWidth: 110,
      },
      {
        accessor: 'total_price',
        width: 150,
        Header: () => (
          <IconTd
            sorter={
              sorter === 'total_price' || sorter === '-total_price'
                ? sorter
                : null
            }
          >
            {__('SUMA BEZ DPH')}
          </IconTd>
        ),

        Cell: props => {
          let price = 0;

          props.original.SalesLines &&
            props.original.SalesLines.forEach(s => {
              price += Number(s.Line_Amount) || 0;
            });

          return (
            <P
              onClick={() => this.openOrderDetail(props.original.No)}
              style={{ textAlign: 'end' }}
            >
              {formatPrice({
                amount: price,
                currency: this.props.user.firm === 'SK' ? 'EUR' : 'CZK',
              })}
            </P>
          );
        },
        maxWidth: 1120,
      },
      {
        accessor: 'Status',
        Cell: props => {
          return (
            <P
              onClick={() => this.openOrderDetail(props.original.No)}
              style={{ textAlign: 'center' }}
            >
              {orderStateTrans(props.value)}
            </P>
          );
        },
        Header: () => (
          <IconTd
            sorter={sorter === 'state' || sorter === '-state' ? sorter : null}
          >
            {__('STAV')}
          </IconTd>
        ),
        maxWidth: 120,
      },
      {
        accessor: 'No',
        maxWidth: 150,
        Header: () => <IconTd>{__('Zobraziť / Stiahnuť')}</IconTd>,
        Cell: props => {
          return (
            <DownloadWrapper>
              <FileViewDownload
                name={props.value}
                history={this.props.history}
                downloadFunction={async () => {
                  return API2.getB2BOrderInvoiceAction(props.value);
                }}
                error={error => {
                  this.setState({ error });
                }}
              />
            </DownloadWrapper>
          );
        },
      },
      {
        accessor: 'order_copy_to_cart',
        maxWidth: 75,
        Header: () => <IconTd>{__('KÓPIA')}</IconTd>,
        Cell: row => (
          <FlexBox>
            <SpaceWrapper>
              <AddToCartWrapperDesktop
                onClick={() => this.createCartFromOrder(row.row.No)}
                // loading={this.props.copyOrderLoading}
              >
                {this.state.copyOrderLoading === row.row.No ? (
                  <Loader />
                ) : (
                  <Icon name="cart" color="#70af00" />
                )}
              </AddToCartWrapperDesktop>
            </SpaceWrapper>
          </FlexBox>
        ),
      },
    ];
  }

  renderCustomHeaderContent() {
    const { loading, month } = this.state;

    return (
      <MonthsWrapper>
        <P>{__('Mesiac:')}</P>
        <Select
          disabled={loading}
          size="xs"
          style={{
            height: rem(28),
            borderRadius: rem(2),
          }}
          onChange={e =>
            this.setState(
              {
                month: e.target.value,
              },
              () => {
                this.fetchData();
              },
            )
          }
        >
          <option value={-1} selected={month < 1}>
            {__('Všetky')}
          </option>
          {months.map(m => {
            return (
              <option value={m.number} selected={month === m.number}>
                {m.label}
              </option>
            );
          })}
        </Select>
      </MonthsWrapper>
    );
  }

  renderCustomContent() {
    const {
      customContentLoading,
      actualYear,
      yearLoading,
      months,
      summary,
    } = this.state;

    const graphStats = [];

    months.forEach(m => {
      graphStats.push(
        summary.find(s => s.month === m) &&
          summary.find(s => s.month === m).amount &&
          summary.find(s => s.month === m).amount.amount
          ? summary.find(s => s.month === m).amount.amount
          : 0,
      );
    });
    const ordersPriceTotal = {
      amount: graphStats.reduce((partialSum, a) => partialSum + a, 0),
      currency: this.props.user.firm === 'SK' ? 'EUR' : 'CZK',
    };

    return (
      <AnimatedFormMessageWrapper display={!customContentLoading}>
        <ResponsiveFlexWrapper style={{ marginTop: rem(8) }}>
          <StyledPartWrapper width="65%">
            <OrdersGraph
              header={`${__('Prehľad objednávok')} ${actualYear}`}
              data={{
                orders: graphStats,
              }}
              loading={customContentLoading}
            />
          </StyledPartWrapper>
          <PartWrapper width="35%">
            <SliderWrapper>
              <YearsSlider
                loading={yearLoading}
                onClick={side => {
                  this.handleYearChange(side);
                }}
                selectedYear={actualYear}
              />
            </SliderWrapper>
            <InfoBox>
              <Label> {__('Spolu objednávky')} </Label>
              {formatPrice(ordersPriceTotal)}
            </InfoBox>
          </PartWrapper>
        </ResponsiveFlexWrapper>
      </AnimatedFormMessageWrapper>
    );
  }

  render() {
    return super.render();
  }
}

Orders.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

Orders.defaultProps = {
  user: {
    name: '',
    surname: '',
    email: '',
    phone: '',
    role: '',
  },
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Orders);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Orders/List/index.jsx